import { call, put, takeEvery, all } from 'redux-saga/effects'
import paymentsConnectTypes from './paymentsConnectTypes'
import * as paymentsConnectActions from './paymentsConnectActions'
import MyPayments from '../../services/PaymentService/MyPayments'

export function * getTriumphPayUrl () {
  try {
    const { data } = yield call(MyPayments.getTriumphPayUrl)
    yield put(paymentsConnectActions.getTriumphPayUrlSuccess(data))
  } catch (error) {
    yield put(paymentsConnectActions.getTriumphPayUrlFailure(error.message))
  }
}

export function * generateTriumphPayToken (action) {
  try {
    const { payload, callback } = action
    const { data } = yield call(MyPayments.generateTriumphPayToken, payload)
    yield put(paymentsConnectActions.generateTriumphPayTokenSuccess(data))
    if (callback) yield callback()
  } catch (error) {
    yield put(paymentsConnectActions.generateTriumphPayTokenFailure(error.message))
  }
}

export function * onGetTriumphPayUrl () {
  yield takeEvery(paymentsConnectTypes.GET_TRIUMPH_PAY_URL, getTriumphPayUrl)
}

export function * onGetTriumphPayToken () {
  yield takeEvery(paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN, generateTriumphPayToken)
}

export function * paymentsConnectSaga () {
  yield all([
    call(onGetTriumphPayUrl),
    call(onGetTriumphPayToken)
  ])
}
